var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBolimianban(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 4774"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631313",
    x: 1.5,
    y: 2.3125,
    width: 14,
    height: 11.375,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631314",
    x: 2.9375,
    y: 3.875,
    width: 6.6875,
    height: 8.46875,
    fill: "#00C2FF",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631315",
    x: 10.4375,
    y: 3.875,
    width: 3.59375,
    height: 8.46875,
    fill: "#00C2FF",
    fillOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolimianban);
export default __webpack_public_path__ + "static/media/bolimianban.957718deaa49052e3393631d3d3dfba9.svg";
export { ForwardRef as ReactComponent };